export const SHOW_PROPOSAL_MENU_ITEM = 'SHOW_PROPOSAL_MENU_ITEM';
export const SET_PENDING_PROPOSALS = 'SET_PENDING_PROPOSALS';
export const SET_PENDING_PROPOSAL_MENU_ITEM = 'SET_PENDING_PROPOSAL_MENU_ITEM';
